export enum MachineEventType {
	Breakdown = 10,
	Service = 20,
}